import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux';
import { LoginClientRequest } from '../../Api/AuthClient';
import { AjouteClient } from '../../Redux/actions/actionClient';
import ModalForgotPasswordClient from '../../components/ModalForgotPasswordClient';
import '../../Css/loginClient.css';
import Logo from '../../Image/logo.png';

const LoginClient = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [loading, setLoading] = useState(false);

  let location = useLocation();
  let navigate = useNavigate();
  let dispatch = useDispatch();

  const handlePassword = () => setShowPass(!showPass);



  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    const data = { email: email, password: password };
    LoginClientRequest(data).then(function (response) {
      console.log(response);
      localStorage.setItem('client', JSON.stringify(response.data.donner));
      localStorage.setItem('tokenClient', response.data.token);
      dispatch(AjouteClient(response.data.donner));
      if (response.data.title === "success") {
        navigate('/client/donner');
      }
    }).catch(function (error) {
      console.log(error);
      if (error) {
        toast.error(error.response.data?.message);
      }
    }).finally(function () {
      setLoading(false);
    });
  }
  return (
    <div>
      <Helmet>
        <title>Login ~ Client </title>
        <meta name='description' content='Login client.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='login_client'>
        {loading && <Loader />}
        <div className='col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 mx-auto layout_form'>
          <div className='bloc_form'>
            <div className='d-flex justify-content-center'>
              <div className='login_logo'>
                <img src={Logo} alt="logo e-kaly" />
              </div>
            </div>
            <h1 className='text-center'>Login e-kaly</h1>
            <form onSubmit={handleSubmit} className='form_content'>
              <div className="mb-3">
                <div className='d-flex justify-content-start'>
                  <label className="form-label">Adresse e-mail</label>
                </div>
                <input type="email" className="form-control" id="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Adresse e-mail ..." />
              </div>
              <div className="mb-3">
                <div className='d-flex justify-content-start'>
                  <label className="form-label">Mot de passe</label>
                </div>
                <input type={showPass ? "text" : "password"} required value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" id="password" placeholder="Mot de passe ..." />
              </div>
              <div className='d-flex justify-content-end'>
                <i className={showPass ? 'fa fa-eye-slash' : 'fa fa-eye'} onClick={handlePassword} ></i>
              </div>
              {/* <div className='d-flex justify-content-end'>
                <span onClick={() => setModalShow(true)}>Mot de passe oublié</span>
              </div> */}
              <button type='submit' className='btn w-100'>Connexion</button>
              <div className='d-flex justify-content-center mb-3'>
                <Link to='/inscriptionClient' className='lienInscription'><span>Vous n'avez pas de compte ? <strong>S'inscrire</strong></span></Link>
              </div>
            </form>
            <p className="version">Version 1</p>
          </div>
        </div>
     
      </div>
      <ModalForgotPasswordClient
        show={modalShow}
        onHide={() => setModalShow(false)} />
    </div>
  )
}

export default LoginClient